import { BFFGateway, LeaguesBySportIdRequest, LeaguesResponse } from "sb-resp-lib";
import { LeaguesRetriever, DataProvider } from "../../Typings";

export class AllLeaguesRetriever implements LeaguesRetriever {
    private bff: BFFGateway;
    private dataProvider: DataProvider;
    private loadedData: Function;
    requestAllLeagues: LeaguesBySportIdRequest;

    constructor(bffGateway: BFFGateway, dataProvider: DataProvider, loadedData: Function) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.requestAllLeagues = {};
        this.requestAllLeagues.ids = [dataProvider.sportId];
        this.requestAllLeagues.regionIds = this.dataProvider.regionId;
        this.loadedData = loadedData;
    }

    setRegionIds(regionId: string) {
        this.requestAllLeagues.regionIds = this.dataProvider.regionId.concat(regionId);
    }

    removeRegionId() {
        this.requestAllLeagues.regionIds = [this.dataProvider.regionId[0]];
    }

    loadData() {
        this.bff.getLeaguesBySportId(this.requestAllLeagues)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err) });
    }

    private loadDataSuccessCb(response: LeaguesResponse): void {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}